export default __webpack_public_path__ + "static/media/linkding-bold.081ec813.svg";